const carManagement = {
  bindingCar: "เชื่อมโยงรถ",
  noBindOBD: "โปรดเลือกรหัส OBD",
  speeding: "Speeding",
  sharpturn: "Sharp turn",
  emergencyBrake: "Emergency brake",
  rapidAcceleration: "Rapid acceleration",
  timeOfAppointment: "Time of appointment",
  vehicleUser: "Vehicle user",
  score: "Total Score",
  mileage: "Total Mileage",
  hour: "Total Time",
  bindingState: "สถานะการเชื่อมต่อ",
  brand: "ยี่ห้อ",
  model: "รุ่นย่อย",
  maxSpeed: "ความเร็วสูงสุด",
  dutystatus: "Duty status",
  category: "Category",
  area: "จังหวัด",
  fuelType: "ประเภทน้ำมัน",
  authorize: "Authorized to",
  successfulVerification: "ตรวจสอบความถูกต้อง",
  message: {
    needchange: "Other vehicles are bound to this OBD. Do you want to change the binding?",
    deleteBind: "Bound vehicles cannot be deleted",
    noPermission: "You have no right to change the car information"
  },
  Unbound: "เลิกเชื่อมต่อ",
  binding: "เชื่อมต่อ",
  untyTips: "Whether unbound or not ",
  createTime: "เวลาที่สร้าง",
  notOBD: "รถไม่ได้เชื่อมโยงกับ OBD",
  bindsuccess: "เชื่อมโยงสำเร็จ",
  untysuccess: "การยกเลิกสำเร็จ",
  belong: "เป็นของ",
  personal: "ส่วนบุคคล",
  vinno: "VIN number",
  transmitterNumber: "Engine no",
  series: "รุ่น",
  boundHistory: "ประวัติการเชื่อมต่อ",
  queryWidth: "260",
  tableWidth: {
    licensePlate: "160",
    areaName: "120",
    brandName: "90",
    seriesName: "100",
    modelName: "90",
    barCode: "110",
    carTerminalStatus: "120",
    isPrivate: "100",
    realName: "110",
    cartype: "120",
    authorize: "150"
  },
  createAndUpdate: {
    title1: "ข้อมูลยานพาหนะ",
    title2: "ข้อมูลเจ้าของ",
    title3: "ข้อมูลอุปกรณ์",
    title4: "ข้อมูลอื่น ๆ",
    permanent: "Permanent",
    temporary: "Temporary",
    create: "เพิ่มรถใหม่",
    update: "แก้ไขรถ",
    category: "ประเภท",
    vehicleowner: "Owner",
    leftLabelWidth: "100px",
    rightLabelWidth: "100px",
    error: {
      area: "Please select the vehicle area",
      category: "Please select the vehicle configuration",
      owner: "Please select the owner",
      licenseplate: "Please input the license plate"
    },
    selectTerminal: {
      title: "ดับเบิลคลิกเพื่อเลือกรหัส OBD",
      message: "The terminal doesn't have SIM card",
      tabelWidth1: "100px",
      tabelWidth2: "110px"
    }
  },
  history: {
    title: "View the binding history"
  },
  details: {
    licenseMessage: "(A red bottom represents a temporary licence)"
  },
  tips: "ปลดยานพาหนะ",
  noComments: "โปรดป้อนเหตุผล",
  errorComments: "หมายเหตุมีความยาวไม่เกิน 1-250 อักษร",
  buttonLabelWidth: "120px",
  regVin: "หมายเลขตัวถัง (ลงทะเบียน)",
  ecuVin: "หมายเลขตัวถัง (ECU)",
  ecuVinRefreshTime: "เวลารีเฟรช ECU",
  count: {
    total: "ยานพาหนะทั้งหมด",
    binding: "การเชื่อมโยงทั้งหมด",
    unbinding: "การยกเลิกเชื่อมโยงทั้งหมด"
  },
  company: "บริษัท",
  subCompany: "Sub Company",
  department: "Department",
  operate: {
    open: "On",
    close: "Off",
    unlock: "ปลดล็อค",
    atresia: "ล็อค",
    pending: "Pending",
    width: '370px',
    tboxwidth: '390px',
    success: 'Command issued successfully',
    operateTip: "Are you sure to issue the command?",
    unlockTip: "คุณแน่ใจหรือว่าคุณต้องการปลดล็อค",
    atresiaTip: "คุณแน่ใจนะว่าต้องการล็อค",
    inputTip: "Please input your password",
  }
}
export default carManagement